import { Action } from '@ngrx/store';
import { PurchaseOrderValidationResponseV4 } from '@cemex-core/cmx-api';
export enum OneClickValidatePurchaseOrderActionTypes {
  LOAD_VALIDATE_PURCHASE_ORDER = '[One Click] Load validate purchase order',
  LOAD_VALIDATE_PURCHASE_ORDER_COMPLETE = '[One Click] Load validate purchase order completed',
  LOAD_ERROR = '[One CLick] Loas error purchase order',
  RESET = '[One Click] validate purchase order reset',
  LOAD = 'LOAD',
}

export class OneClickLoadValidatePurchaseOrderAction implements Action {
  readonly type = OneClickValidatePurchaseOrderActionTypes.LOAD_VALIDATE_PURCHASE_ORDER;

  constructor() {}
}

export class OneClickLoadValidatePurchaseOrderCompleteAction implements Action {
  readonly type = OneClickValidatePurchaseOrderActionTypes.LOAD_VALIDATE_PURCHASE_ORDER_COMPLETE;

  constructor(public payload: PurchaseOrderValidationResponseV4) {}
}

export class OneClickErrorLoadalidatePurchaseOrderAction implements Action {
  readonly type = OneClickValidatePurchaseOrderActionTypes.LOAD_ERROR;

  constructor(public payload: any) {}
}

export class OneClickResetValidatePurchaseOrderAction implements Action {
  readonly type = OneClickValidatePurchaseOrderActionTypes.RESET;

  constructor() {}
}

export type OneClickValidatePurchaseOrderActions =
  | OneClickLoadValidatePurchaseOrderAction
  | OneClickLoadValidatePurchaseOrderCompleteAction
  | OneClickErrorLoadalidatePurchaseOrderAction
  | OneClickResetValidatePurchaseOrderAction;
